import { Card } from "antd";

const estiloPadrao = {
  marginBottom: 16,
};

export function SecaoCard({ title, extra, children, style, ...rest }) {
  return (
    <Card
      title={title}
      extra={extra}
      size="small"
      style={{ ...estiloPadrao, ...style }}
      {...rest}
    >
      {children}
    </Card>
  );
}
